import React from 'react';
import { AccordionProps } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import { AccordionRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRule';
import { MerchantRestrictionsRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/MerchantRestrictionsRule/MerchantRestrictionsRuleHeader/MerchantRestrictionsRuleHeader';
import { MerchantRestrictionsRuleBody } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/MerchantRestrictionsRule/MerchantRestrictionsRuleBody/MerchantRestrictionsRuleBody';

export type MerchantRestrictionsRuleProps = Omit<
  AccordionProps,
  'header' | 'body'
>;

export function MerchantRestrictionsRule({
  ...props
}: MerchantRestrictionsRuleProps): JSX.Element {
  return (
    <AccordionRule
      {...props}
      header={(isActive): JSX.Element => (
        <MerchantRestrictionsRuleHeader isActive={isActive} />
      )}
      body={(): JSX.Element => <MerchantRestrictionsRuleBody />}
    />
  );
}
